import {Injectable} from '@angular/core';
import {AdminService} from './admin.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Observable} from 'rxjs/Observable';
import {HttpResponse} from '@angular/common/http';
import {Standard} from '../models/standard.model';
import {StandardVersionSnapshot, standardResponseWithVersion} from './standard-version';

export interface StandardDocumentContext { fileId: string; standardId: string; fileLink: string; }
const DOCUMENT_STORAGE = {file: 'DocxID', standard: 'DocxSID', link: 'fileLink'};
const DOCUMENT_BROWSER_STORAGE = localStorage;

export function storeDocumentContext(context: StandardDocumentContext): void {
  Object.keys(DOCUMENT_STORAGE).forEach(key => DOCUMENT_BROWSER_STORAGE.removeItem(DOCUMENT_STORAGE[key]));
  if (context.fileId) { DOCUMENT_BROWSER_STORAGE.setItem(DOCUMENT_STORAGE.file, context.fileId); }
  if (context.standardId) { DOCUMENT_BROWSER_STORAGE.setItem(DOCUMENT_STORAGE.standard, context.standardId); }
  if (context.fileLink) { DOCUMENT_BROWSER_STORAGE.setItem(DOCUMENT_STORAGE.link, context.fileLink); }
}


@Injectable()
export class ViewDocxService {

  // public docxFileALink = 'https://docs.google.com/gview?url=https://file-storage-encata.s3-eu-west-1.amazonaws.com/08-Aug-2018-12%3A14%3A52_prod_tmp_7319137719054852574Manage.1.15.05.15.docx&embedded=true';
  // public url = this.sanitizer.bypassSecurityTrustResourceUrl(this.docxFileALink);

  constructor(public adminService: AdminService,
              public modalService: NgbModal) {
  }


  readDocumentContext(storage: Storage = localStorage): StandardDocumentContext {
    return {
      fileId: storage.getItem(DOCUMENT_STORAGE.file),
      standardId: storage.getItem(DOCUMENT_STORAGE.standard),
      fileLink: storage.getItem(DOCUMENT_STORAGE.link)
    };
  }

  getLinkByDocxID(context = this.readDocumentContext()): Observable<HttpResponse<string>> | null {
    return context.fileId && context.standardId
      ? this.adminService.getTempDocxFileLink(context.fileId, context.standardId) : null;
  }

  loadDocumentStandard(context: StandardDocumentContext): Observable<HttpResponse<Standard>> {
    return this.adminService.getStandard(context.standardId)
      .map((response: HttpResponse<Standard>) => standardResponseWithVersion(response));
  }

  prepareDocument(context: StandardDocumentContext, snapshot: StandardVersionSnapshot): Observable<HttpResponse<string>> {
    return this.adminService.prepareStandardDocx(context.fileId, snapshot);
  }

  deleteLinkByDocxID() {
  }

  deleteDocxManually(fileLink, sID) {
    return this.adminService.deleteTempDocxFileManually(fileLink, sID);
  }

  clearTempFileLoacalStorage() {
    localStorage.removeItem('DocxID');
    localStorage.removeItem('DocxSID');
  }

  deleteLinkByDocxIDManually() {
    localStorage.removeItem('fileLink');
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/view-docx.service.ts